import {
  CLEAR_SELECTED_JOB,
  GET_JOB_MARKET_ELEMENTS,
  GET_MARKET_ELEMENTS,
  JOB_RANGE,
  SET_SELECTED_JOB,
  UPDATE_VALUES
} from './SalaryRangeActions';

const initialState = {
  jobMarketElements: null,
  jobRange: null,
  marketElements: {},
  maxSalaryRange: {},
  midSalaryRange: {},
  minSalaryRange: {},
  selectedJob: {},
  roundTo: 1
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLEAR_SELECTED_JOB:
      return {
        ...initialState
      };
    case GET_JOB_MARKET_ELEMENTS:
      return {
        ...state,
        jobMarketElements: action.data.payElements
      };
    case GET_MARKET_ELEMENTS:
      return {
        ...state,
        marketElements: action.data
      };
    case JOB_RANGE: {
      const data = action.data;
      const payElements = state.marketElements.payElements;
      const defaultMarketElement = payElements.find(element => element.source_field === 'base_salary_50th')
        .source_field;
      const defaultMarketElementDisplay = payElements.find(
        title => title.field_title === 'Market Base Salary 50th (Median)'
      ).field_title;
      const hasMaxElement = payElements.find(element => element.source_field === data.salaryRangePctElements.max);
      const hasMidElement = payElements.find(element => element.source_field === data.salaryRangePctElements.mid);
      const hasMinElement = payElements.find(element => element.source_field === data.salaryRangePctElements.min);

      return {
        ...state,
        jobRange: data,
        maxSalaryRange: {
          ...state.maxSalaryRange,
          currentSalary: data.salaryRange.max,
          element: hasMaxElement ? hasMaxElement.source_field : defaultMarketElement,
          elementDisplay: hasMaxElement ? hasMaxElement.field_title : defaultMarketElementDisplay,
          percent: data.salaryRangePct.max
        },
        midSalaryRange: {
          ...state.midSalaryRange,
          currentSalary: data.salaryRange.mid,
          element: hasMidElement ? hasMidElement.source_field : defaultMarketElement,
          elementDisplay: hasMidElement ? hasMidElement.field_title : defaultMarketElementDisplay,
          percent: data.salaryRangePct.mid
        },
        minSalaryRange: {
          ...state.minSalaryRange,
          currentSalary: data.salaryRange.min,
          element: hasMinElement ? hasMinElement.source_field : defaultMarketElement,
          elementDisplay: hasMinElement ? hasMinElement.field_title : defaultMarketElementDisplay,
          percent: data.salaryRangePct.min
        },
        roundTo: data.roundTo
      };
    }
    case SET_SELECTED_JOB:
      return {
        ...state,
        selectedJob: action.data
      };
    case UPDATE_VALUES:
      return {
        ...state,
        maxSalaryRange: {
          ...state.maxSalaryRange,
          currentSalary: action.data.salaryRange.max,
          element: action.data.salaryRangePctElements.max,
          percent: action.data.salaryRangePct.max
        },
        midSalaryRange: {
          ...state.midSalaryRange,
          currentSalary: action.data.salaryRange.mid,
          element: action.data.salaryRangePctElements.mid,
          percent: action.data.salaryRangePct.mid
        },
        minSalaryRange: {
          ...state.minSalaryRange,
          currentSalary: action.data.salaryRange.min,
          element: action.data.salaryRangePctElements.min,
          percent: action.data.salaryRangePct.min
        }
      };
    default:
      return { ...state };
  }
}

export const SalaryRangeActions = {};
